import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { TransparentBgButton } from 'components/Shared/Button'
import ProgressWizard from './ProgressWizard'

export default function ProgressView({ campaign, onClose }) {
  const { t } = useTranslation()

  const startTime = useMemo(
    () => new Date(campaign.date_created).getTime(),
    [campaign.date_created],
  )
  const elapsed = useMemo(() => Date.now() - startTime, [startTime])
  const showLongMessage = elapsed > 5 * 60 * 1000

  return (
    <div className="test-campaign-progress-view">
      <div className="test-campaign-progress-view__content">
        <h1>{t('Settings.MetaAccess.TestCampaign.creatingTitle', 'Creating Test Campaign')}</h1>
        <p className="body-txt mb-4 text-left">
          {showLongMessage
            ? t(
              'Settings.MetaAccess.TestCampaign.creatingLongDescription',
              'This is taking longer than expected. You can close this and check back later.',
            )
            : t(
              'Settings.MetaAccess.TestCampaign.creatingDescription',
              'We are creating your test campaign. This usually takes just a few minutes.',
            )}
        </p>

        <div className="test-campaign-progress-view__wizard">
          <ProgressWizard campaign={campaign} />
        </div>

        <p className="body-txt mt-4 text-left">
          {t(
            'Settings.MetaAccess.TestCampaign.progressNote1',
            'This usually takes just a few minutes. You can leave this page and return later',
          )}
        </p>

        <p className="body-txt mt-2 text-left">
          {t(
            'Settings.MetaAccess.TestCampaign.progressNote2',
            'You’ll be able to start a new test as soon as the current one finishes.',
          )}
        </p>
      </div>

      <div className="test-campaign-progress-view__footer">
        <TransparentBgButton
          text={t('common.close', 'Close')}
          onClick={onClose}
          color="navy"
          fullWidth
        />
      </div>
    </div>
  )
}

ProgressView.propTypes = {
  campaign: PropTypes.shape({
    status: PropTypes.string.isRequired,
    stage: PropTypes.string,
    date_created: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
}
